export const searchBoxFilterStyle =
	'border-border bg-card hover:border-foreground/50 text-foreground/80 h-11 cursor-pointer w-full border px-4 text-left text-base font-medium whitespace-nowrap shadow-md disabled:cursor-not-allowed disabled:opacity-50'

export function clearSearchPlaceParams(searchParams: URLSearchParams) {
	const sp = new URLSearchParams(searchParams.toString())
	sp.delete('swLat')
	sp.delete('swLng')
	sp.delete('neLat')
	sp.delete('neLng')
	sp.delete('page')
	sp.delete('radius')
	sp.delete('nearby')
	sp.delete('city')
	sp.delete('country')

	return sp
}
